<template>
  <b-form class="px-2 mb-3">
    <b-row>
      <b-col lg="3">
        <b-form-group
          label="Variations"
          label-class="product-creation-section-labels py-0"
        >
          <small class="sub-section-labels"
            >Create various product versions</small
          >
        </b-form-group>
      </b-col>
      <b-col lg="5">
        <b-form-group>
          <ProductVariationsSingle
            :items="items"
            :stored-inventory="storedInventory"
          />
        </b-form-group>
        <b-form-group>
          <b-button
            variant="ghost"
            class="text-primary border font-weight-bold create-button px-3"
            @click="create"
          >
            + Create Variant
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <ProductVariationModal :is_manage="is_manage" />
  </b-form>
</template>

<script>
import { mapState } from "vuex";
import ProductVariationModal from "./ProductVariationModal";
import ProductVariationsSingle from "./ProductVariationsSingle";

export default {
  props: {
    storedInventory: Array,
  },
  components: { ProductVariationsSingle, ProductVariationModal },
  data() {
    return {
      is_manage: false,
    };
  },
  computed: {
    ...mapState("products", ["product_variables"]),
    items() {
      return this.product_variables;
    },
  },
  methods: {
    create() {
      this.$root.$emit("bv::show::modal", "product-variation-modal");
    },
  },
};
</script>
